import React from "react";
import { FlexBetween } from "../../../../../layout/FlexBetween/FlexBetween";
import { FlexCenter } from "../../../../../layout/FlexCenter/FlexCenter";
import IconComponent from "../../../../../shared/IconComponents/IconComponent";
import { Loader } from "../../../../../shared/Loader/Loader";
import { CleanButton } from "../../../../../ui/CleanButton";
import { TextCustom } from "../../../../../ui/TextCustom";
import { IFileInfo } from "../../../../../../interface/interfaces";

interface IAiAnalyzerFileButtonProps{
    func: () => void;
    file: IFileInfo
}


export const AiAnalyzerFileButton: React.FC<IAiAnalyzerFileButtonProps> = ({func, file}) => {
    return (
        <div style={{ width: '100%' }}>
            <FlexCenter position="start" direction="v">
                <FlexBetween>
                    <CleanButton
                        disabled={file.status === 'Uploading...' || file.status === 'Failed' ? true : false}
                        useBg
                        func={func}
                        hasCursor={file.status === 'Uploading...' || file.status === 'Failed' ? false : true}
                    >
                        <FlexCenter direction="v" position="center">
                            <IconComponent size={1.5} iconName={'File'} />
                            <TextCustom size={1.2} color={`${file.status === 'Uploading...' ? 'grey-normal' : 'dark'}`}>
                                {file.name}
                            </TextCustom>
                        </FlexCenter>
                    </CleanButton>

                    {
                        file.status !== 'triggered' ? (
                            <Loader width={15} height={15} color="grey-dark" />
                        ) : (
                            <div className={`${'animation-scale-2'}`}>
                                <IconComponent size={1.5} iconName={'OK'} />
                            </div>
                        )
                    }
                </FlexBetween>
            </FlexCenter>
        </div>
    )
}